import { TableHeader } from "@/models/TableHeader";

export const aceEmailHeaders: TableHeader[] = [
  {
    text: "Email Name",
    value: "name"
  },
  {
    text: "Scheduled",
    value: "scheduled"
  },
  {
    text: "Sent",
    value: "sent"
  }
];
